import * as TokenInformationActions from './token-information.actions';
import { TokenInformation } from './token-information.model';

export interface State {
  tokenInformation: TokenInformation;
}

const initialState: State = {
  tokenInformation: {
    userId: '',
    storeLocationId: '',
    orgId: ''
  }
};

export function tokenInformationReducer(state = initialState, action: TokenInformationActions.TokenInformationActions) {
  switch (action.type) {
    case (TokenInformationActions.Add_TokenInformation):

      const updatedTokenInformation = action.payload;


      let updatedTokenInfo = state.tokenInformation;
      updatedTokenInfo = updatedTokenInformation;

      return {
        ...state,
        tokenInformation: updatedTokenInfo
      };

    default:
      return state;
  }
}
